import AppPath from "../../../components/App/models/AppPath";

class QTMPath extends AppPath {
  public static readonly QTM = new AppPath({
    id: "qtm",
    label: "QTM Student Onboarding",
    path: "/qtm",
  });

  public static readonly DSci = new AppPath({
    id: "dsci-student-onboarding",
    label: "DSci Student Onboarding",
    path: "/forms/dsci-student-onboarding",
  });
}
export default QTMPath;
